import { DocumentTypeEffects as DocumentTypes } from './doc-admin.effects';
import { DocumentTypeDetailsEffects as DocumentTypesDetails } from './doc-admin-details.effects';

export const DocumentTypeEffects = [DocumentTypes, DocumentTypesDetails];
